export const TableHeaders = {
  Employee: {
    List: [
      { text: '', align: 'center', sortable: false, value: 'profile_image_url', width: '5%' },
      { text: 'Employee', align: 'left', sortable: false, value: 'full_name', width: '20%' },
      { text: 'Department', align: 'left', sortable: false, value: 'department' },
      { text: 'Location', align: 'left', sortable: false, value: 'job_location' },
      { text: 'Phone number', align: 'left', sortable: false, value: 'phone_number' },
      { text: 'Status', align: 'left', sortable: false, value: 'type' },
    ],
    Document: [
      { text: 'Name', align: 'left', sortable: false },
      { text: 'Type', align: 'left', sortable: false },
      { text: 'Format', align: 'left', sortable: false },
      { text: 'URL', align: 'left', sortable: false },
      { text: 'Uploaded Document', align: 'left', sortable: false, value: "storage_ref" },
      { text: 'Action', align: 'center', sortable: false },
    ],
  },
  Benefits: {
    List: [
      { text: 'Name', align: 'left', sortable: false, value: 'name' },
      {
        text: 'Provider',
        align: 'left',
        sortable: false,
        value: 'provider_name',
      },
      { text: 'Category', align: 'left', sortable: false, value: 'category' },
      {
        text: 'Created By',
        align: 'left',
        sortable: false,
        value: 'admin_benefit',
      },
    ],
  },
  Announcement: {
    List: [
      { text: 'Title', align: 'left', sortable: false, value: 'title' },
      { text: 'Type', align: 'left', sortable: false, value: 'type' },
      { text: 'Created On', align: 'left', sortable: false, value: 'created_at_formatted' },
      { text: 'Expires On', align: 'left', sortable: false, value: 'expires_at_formatted' },
    ],
  },
  TimeOff: {
    List: [
      { text: 'Type', align: 'left', sortable: false, value: 'type' },
      { text: 'Approver Name', align: 'left', sortable: false, value: 'approver_name' },
      { text: 'Start Date', align: 'left', sortable: true, value: 'start_date' },
      { text: 'End Date', align: 'left', sortable: true, value: 'end_date' },
      { text: "Total Days", align: 'left', sortable: false, value: 'total_days' },
      { text: "Message", align: 'left', sortable: false, value: 'text' },
      // { text: 'this_year', align: 'left', sortable: true, value: 'days_this_year' },
      // { text: 'next_year', align: 'left', sortable: true, value: 'days_next_year' },
      // { text: 'carryover', align: 'left', sortable: true, value: 'carryover_days' },
      // { text: 'restriction_attempt', align: 'left', sortable: true, value: 'restriction_attempt' },
      // { text: 'restriction_attempt_next', align: 'left', sortable: true, value: 'restriction_attempt_next_year' },
      { text: 'Status', align: 'left', sortable: true, value: 'status' },
      // { text: 'Action', align: 'left', sortable: false, value: 'id' },
    ],
    Approve: [
      { text: 'Employee', align: 'left', sortable: false, value: 'user_name' },
      { text: 'Type', align: 'left', sortable: false, value: 'type' },
      {text: 'Policy Type', align: 'left', sortable: false, value: 'leave_type'},
      {text: 'From', align: 'left', sortable: true, value: 'start_date_formatted'},
      {text: 'To', align: 'left', sortable: true, value: 'end_date_formatted'},
      {text: 'Total Days', align: 'left', sortable: false, value: 'total_days'},

      // { text: 'this_year', align: 'left', sortable: true, value: 'days_this_year' },
      // { text: 'next_year', align: 'left', sortable: true, value: 'days_next_year' },
      // { text: 'carryover', align: 'left', sortable: true, value: 'carryover_days' },
      // { text: 'restriction_attempt', align: 'left', sortable: true, value: 'restriction_attempt' },
      // { text: 'restriction_attempt_next', align: 'left', sortable: true, value: 'restriction_attempt_next_year' },
      {text: 'Approval Status', align: 'right', sortable: false, value: 'status'},
      {text: 'Delete request', align: 'right', sortable: false, value: 'id'},
    ],
  },
  Departments: [
    {text: 'Name', align: 'left', sortable: false, value: 'name'},
    {text: 'Description', align: 'left', sortable: false, value: 'description'},
    // {text: 'No of employees', align: 'left', sortable: false, value: 'count'},
  ],
  Calendar: {
    Calendar: [
      {text: 'Country Name', align: 'left', sortable: false, value: 'country_name'},
      {text: 'Country Code', align: 'left', sortable: false, value: 'country_code'},
      {text: 'Action', align: 'right', sortable: false, value: 'id'},
    ],
    Preview: [
      {text: 'Country Name', align: 'left', sortable: false, value: 'country_name'},
      {text: 'Date', align: 'left', sortable: true, value: 'formatted_date'},
      {text: 'Title', align: 'left', sortable: false, value: 'title'},
      {text: 'Action', align: 'right', sortable: true, value: 'id'},
    ],
  }
  ,
  Backoffice: {
    List: [
      {text: 'Name', align: 'left', sortable: false, value: 'name'},
      {text: 'Type', align: 'left', sortable: false, value: 'type'},
      {text: 'Updated By', align: 'left', sortable: false, value: 'updated_by'},
      {text: 'Updated At', align: 'left', sortable: false, value: 'updated_at'},
    ],
  },
  Locations: [
    {text: 'Title', align: 'left', sortable: false, value: 'title'},
    {text: 'City', align: 'left', sortable: false, value: 'city'},
    {text: 'Country', align: 'left', sortable: false, value: 'country'},
    {text: 'Postcode', align: 'left', sortable: false, value: 'post_code'},
  ],
  Workflow: [
    { text: 'Workflow name', align: 'left', sortable: false },
    { text: 'Workflow type', align: 'left', sortable: false },
    { text: 'No of tasks', align: 'left', sortable: false },
  ],
  WorkflowTasks: [
    { text: 'Task name', align: 'left', sortable: false, value: 'name' },
    { text: 'Owner', align: 'left', sortable: false, value: 'assigned_to' },
    { text: 'Description', align: 'left', sortable: false, value: 'description' },
  ],
  Leaves: [
    { text: 'Name', align: 'left', sortable: false, value: 'name' },
    { text: 'Accrual', align: 'left', sortable: false, value: 'accrual.enabled' },
    {
      text: 'Restrictions',
      align: 'left',
      sortable: false,
      value: 'restrictions.enabled',
    },
    //{ text: 'Prorate', align: 'left', sortable: false, value: 'prorate.enabled' },
    { text: 'Valid for all days', align: 'left', sortable: true, value: 'count_holidays' },
    {
      text: 'Carryover',
      align: 'left',
      sortable: false,
      value: 'carryover.enabled',
    },
    // { text: 'Action', align: 'left', sortable: false, value: 'id' },
  ],
  MarketPlace: [
    { text: 'Name', align: 'left', sortable: false },
    { text: 'Category', align: 'left', sortable: false },
    { text: 'Market', align: 'left', sortable: false },
    { text: 'Active', align: 'left', sortable: false },
  ],
  Membership: [
    {text: 'ID', align: 'left', sortable: false, value: 'id'},
    {text: 'Start', align: 'left', sortable: false, value: 'from'},
    {text: 'End', align: 'left', sortable: false, value: 'to'},
    {text: 'Status', align: 'left', sortable: false, value: 'status'},
    {text: 'Amount', align: 'left', sortable: false, value: 'amount'},
    {text: 'Currency', align: 'left', sortable: false, value: 'currency'},
    {text: 'Type', align: 'left', sortable: false, value: 'type'},
  ],
  Access: {
    Log: [
      {text: 'Email', align: 'left', sortable: false, value: 'user_email'},
      {text: 'From', align: 'left', sortable: false, value: 'from'},
      {text: 'To', align: 'left', sortable: false, value: 'to'},
      {text: 'Date', align: 'left', sortable: false, value: 'created_at'},
      {text: 'Changed By', align: 'left', sortable: false, value: 'changed_by_email'},
    ],
    List: [
      {text: 'Email', align: 'left', sortable: false, value: 'work_email'},
      {text: 'Role', align: 'left', sortable: false, value: 'role'},
    ]
  }
};